import { Component, ViewChild } from '@angular/core';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { subMenuItems } from '../submenu';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@shared/services/api.service';
import { TokenService } from '@shared/services/token.service';
import { UtilsService } from '@shared/services/utils.service';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { Subject, debounceTime, distinctUntilChanged, firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaymentsMenuService } from '@shared/services/payments-menu.service';

@Component({
  selector: 'app-proformas',
  templateUrl: './proformas.component.html',
  styleUrls: ['./proformas.component.scss']
})
export class ProformasComponent {

  @ViewChild(Table) dt!: Table;
  public subMenuItems: Array<IToolbarItem> = [];
  public searcherCriteria: string = '';
  public loading: boolean = false;
  public filteredInvoices: any[] = [];
  public totalRecords: number = 0;
  private searchSubject = new Subject<string>();
  public currentPage: number = 0;


  constructor(
    private apiService: ApiService,
    public utils: UtilsService,
    private tokenService: TokenService,
    private subMenuService: PaymentsMenuService

  ) { }

  ngOnInit(): void {
    this.subMenuItems = this.subMenuService.getSubMenuItems();

    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchText => {
      this.filterResults(searchText);
    });
    this.loadInvoices({ first: 0 });
  }

  filterResults(searchText: string) {
    this.dt.clear();
    if (searchText.trim() == '') {
      this.searcherCriteria = '';
    }
    this.loadInvoices();
  }

  async loadInvoices(event?: TableLazyLoadEvent) {
    this.totalRecords = 0;
    this.loading = true;
    if (event) {
      this.currentPage = Number((event?.first === 0 || event?.first == undefined) ? 1 : event.first / (event.rows == undefined ? 1 : event.rows) + 1);
    }
    let res: any = await firstValueFrom(this.apiService.getProformasPaginated(this.currentPage, this.searcherCriteria));
    console.log('res: ', res);
    this.filteredInvoices = res.data;
    this.totalRecords = res.total_invoices;

    this.loading = false;
  }

  transformInvoiceNumber(invoiceNumber: any): string {
    return String(invoiceNumber || '').padStart(7, '0');
  }

  onSearchInput(event: any) {
    const searchText = event.target.value || '';
    if (typeof searchText === 'string') {
      this.searchSubject.next(searchText);
    }
  }

  download(id: number, invoice?: any) {
    let token = this.tokenService.getToken();
    window.open(`${environment.baseUrlWeb}/proformas/get/${id}?token=${token}`, '_blank');
  }

  ngOnDestroy() {
    this.searchSubject.unsubscribe();
  }

}
